import React from "react";
import PropTypes from "prop-types";

import "./FromSection.css";

export function FormSection({
  title,
  description,
  children,
  modifier = "",
  className = "",
}) {
  const sectionClasses = [
    "katch-form-section",
    modifier && `katch-form-section--${modifier}`,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const hasHeader = Boolean(title || description);

  return (
    <section className={sectionClasses}>
      {hasHeader && (
        <header className="katch-form-section__header">
          {title && <h3 className="katch-form-section__title">{title}</h3>}

          {description && (
            <p className="katch-form-section__description">{description}</p>
          )}

          <div className="katch-form-section__divider" aria-hidden="true" />
        </header>
      )}

      <div className="katch-form-section__content">{children}</div>
    </section>
  );
}

FormSection.propTypes = {
  title: PropTypes.node,
  description: PropTypes.node,
  children: PropTypes.node,
  modifier: PropTypes.string,
  className: PropTypes.string,
};
